import img from "./../../assets/Kartikeya-Singh.png";
import akshatsrivastava from "./../../assets/ecellimages/akshat-srivastava.jpeg";
import deepshikha from "./../../assets/ecellimages/deep-shikha.jpeg";
import dharunshankar from "./../../assets/ecellimages/dharun-shankar.jpeg";
import diptanudebnath from "./../../assets/ecellimages/diptanu-debnath.jpeg";
import hemantshankar from "./../../assets/ecellimages/hemant-shankar.jpeg";
import janmeshjoshi from "./../../assets/ecellimages/janmesh-joshi.jpeg";
import kajalk from "./../../assets/ecellimages/kajal-k.jpeg";
import krishnachandak from "./../../assets/ecellimages/krishna-chandak.jpeg";
import madhumitamoi from "./../../assets/ecellimages/madhumita-moi.jpeg";
import mukulkumar from "./../../assets/ecellimages/mukul-kumar.jpeg";
import nababratadeb from "./../../assets/ecellimages/nababrata-deb.jpeg";
import pranjaltank from "./../../assets/ecellimages/pranjal-tank.jpeg";
import pratnadeepbanik from "./../../assets/ecellimages/pratnadeep-banik.jpeg";
import srijadas from "./../../assets/ecellimages/banani-das.jpeg";
import rohitn from "./../../assets/ecellimages/rohit-n.jpeg";
import triasharoy from "./../../assets/ecellimages/triasha-roy.jpeg";
import tanmayshree from "./../../assets/ecellimages/tanmay-shree.jpg";
import rashmitachakraborty from "./../../assets/ecellimages/rashmita-chakraborty.jpg";
import rakjhushkumar from "./../../assets/ecellimages/rajkhush-kumar.jpg";
import sumandeb from "./../../assets/ecellimages/suman-deb.jpg";
import aryanvijaywargia from "./../../assets/ecellimages/aryanvijaywargia.jpeg";
import bharatsharma from "./../../assets/ecellimages/bharatsharma.png";
import anubhavray from "./../../assets/ecellimages/anubhavray.jpeg";
import likhitasurya from "./../../assets/ecellimages/likhita.png";
import amitkumar from "./../../assets/ecellimages/amitkumar.png";
import ankitkumar from "./../../assets/ecellimages/ankitkumar.png";
import sadhnabolla from "./../../assets/ecellimages/sadhanabolla.png";
import saikrishna from "./../../assets/ecellimages/saikrishna.png";
import abhijeetpatil from "./../../assets/ecellimages/abhijeetpatil.png";
import aninditapaul from "./../../assets/ecellimages/aninditapaul.png";


export const Faculty_Advisor = [
    {
        index: 0,
        image: sumandeb,
        name: "Dr. Suman Deb",
        post: "Chairman & Faculty Advisor",
        linkdUrl: "#"
    },
]


export const Executive_Team = [
    {
        index: 0,
        image: rakjhushkumar,
        name: "Rajkhush Kumar",
        post: "President",
        linkdUrl: "#",
    },
    {
        index: 1,
        image: img,
        name: "Kartikeya Singh",
        post: "Chief Coordinator",
        linkdUrl: "https://www.linkedin.com/in/sadhana-bolla/",
    },
    {
        index: 2,
        image: rashmitachakraborty,
        name: "Rashmita Chakraborty",
        post: "Operational Head",
        linkdUrl: "https://www.linkedin.com/in/likhitha-surya-sri/",
    },
]

export const Design_Team = [
    {
        index: -2,
        image: bharatsharma,
        name: "Bharat Sharma",
        post: "Lead",
        linkdUrl: "https://www.linkedin.com/in/tanmayshree/",
    },
    {
        index: -1,
        image: anubhavray,
        name: "Anubhav Ray",
        post: "Lead",
        linkdUrl: "https://www.linkedin.com/in/tanmayshree/",
    },
    {
        index: 0,
        image: tanmayshree,
        name: "Tanmay Shree",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/tanmayshree/",
    },
    {
        index: 1,
        image: deepshikha,
        name: "Deep Shikha",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/deepshikha56/",
    },
    {
        index: 2,
        image: nababratadeb,
        name: "Nababrata Deb",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/deepshikha56/",
    }
]

export const Content_Team = [
    {
        index: -1,
        image: aryanvijaywargia,
        name: "Aryan Vijaywargia",
        post: "Lead",
        linkdUrl: "https://www.linkedin.com/in/tanmayshree/",
    },
    {
        index: 0,
        image: hemantshankar,
        name: "Hemant Shankar",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/hemant-shankar/",
    },
    {
        index: 1,
        image: srijadas,
        name: "Srija Das",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/srija-das/",
    },
    {
        index: 2,
        image: akshatsrivastava,
        name: "Akshat Srivastava",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/akshatsrivastava01/",
    },
    {
        index: 3,
        image: kajalk,
        name: "Kajal Kumari",
        post: "Member",
        linkdUrl: "#",
    },
    {
        index: 4,
        image: triasharoy,
        name: "Triasha Roy",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/triasharoy/",
    }
]

export const Outreach_Team = [
    {
        index: -1,
        image: rashmitachakraborty,
        name: "Rashmita Chakraborty",
        post: "Lead",
        linkdUrl: "https://www.linkedin.com/in/tanmayshree/",
    },
    {
        index: 0,
        image: dharunshankar,
        name: "Dharun Shankar",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/dharun-shankar/",
    },
    {
        index: 1,
        image: deepshikha,
        name: "Deep Shikha",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/deepshikha56/",
    },
    {
        index: 2,
        image: madhumitamoi,
        name: "Madhumita Moi",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/madhumita-moi/",
    }
]

export const Alumni_Team = [
    {
        index: 0,
        image: pranjaltank,
        name: "Pranjal Tank",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/pranjal-tank/",
    },
    {
        index: 1,
        image: madhumitamoi,
        name: "Madhumita Moi",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/madhumita-moi/",
    },
    {
        index: 2,
        image: janmeshjoshi,
        name: "Janmesh Joshi",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/janmesh-joshi/",
    }
]

export const Finance_Team = [
    {
        index: -1,
        image: abhijeetpatil,
        name: "Abhijeet Patil",
        post: "Lead",
        linkdUrl: "https://www.linkedin.com/in/tanmayshree/",
    },
    {
        index: 0,
        image: hemantshankar,
        name: "Hemant Shankar",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/hemant-shankar/",
    },
    {
        index: 1,
        image: kajalk,
        name: "Kajal Kumari",
        post: "Member",
        linkdUrl: "#",
    },
    {
        index: 2,
        image: pratnadeepbanik,
        name: "Pratnadeep Banik",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/pratnadeepbanik/",
    }
]

export const Tech_Team = [
    {
        index: -1,
        image: ankitkumar,
        name: "Ankit Kumar",
        post: "Lead",
        linkdUrl: "https://www.linkedin.com/in/tanmayshree/",
    },
    {
        index: -1,
        image: amitkumar,
        name: "Amit Kumar",
        post: "Lead",
        linkdUrl: "https://www.linkedin.com/in/tanmayshree/",
    },
    {
        index: 0,
        image: nababratadeb,
        name: "Nababrata Deb",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/nababratadeb/",
    },
    {
        index: 1,
        image: krishnachandak,
        name: "Krishna Chandak",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/krishna-chandak-abc/",
    },
    {
        index: 2,
        image: tanmayshree,
        name: "Tanmay Shree",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/tanmayshree/",
    }
]

export const Startup_Team = [
    {
        index: -1,
        image: rakjhushkumar,
        name: "Rajkhush Kumar",
        post: "Lead",
        linkdUrl: "https://www.linkedin.com/in/tanmayshree/",
    },
    {
        index: 0,
        image: rohitn,
        name: "Rohit Nori",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/rohit-nori/",
    },
    {
        index: 1,
        image: akshatsrivastava,
        name: "Akshat Srivastava",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/akshatsrivastava01/",
    },
    {
        index: 2,
        image: diptanudebnath,
        name: "Diptanu Debnath",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/diptanu-debnath04/",
    },
    {
        index: 3,
        image: janmeshjoshi,
        name: "Janmesh Joshi",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/janmesh-joshi/",
    },
    {
        index: 4,
        image: dharunshankar,
        name: "Dharun Shankar",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/dharun-shankar/",
    }
]

export const Events_Team = [
    {
        index: -1,
        image: img,
        name: "Kartikeya Singh",
        post: "Lead",
        linkdUrl: "https://www.linkedin.com/in/tanmayshree/",
    },
    {
        index: 0,
        image: pranjaltank,
        name: "Pranjal Tank",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/pranjal-tank/",
    },
    {
        index: 1,
        image: pratnadeepbanik,
        name: "Pratnadeep Banik",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/pratnadeepbanik/",
    },
    {
        index: 2,
        image: mukulkumar,
        name: "Mukul Kumar",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/mukul-kr/",
    }
]

export const Others_Team = [
    {
        index: -1,
        image: saikrishna,
        name: "Sai Krishna Varanasi",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/tanmayshree/",
    },
    {
        index: 0,
        image: sadhnabolla,
        name: "Sadhna Bolla",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/pranjal-tank/",
    },
    {
        index: 1,
        image: likhitasurya,
        name: "Likhita Surya Sri Gullam",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/pratnadeepbanik/",
    },
    {
        index: 2,
        image: aninditapaul,
        name: "Anindita Paul",
        post: "Member",
        linkdUrl: "https://www.linkedin.com/in/mukul-kr/",
    }
]

